import React, { forwardRef } from 'react'
import Button from '@/components/ui/Buttons/Button'
import { ButtonProps } from '@/components/ui/Buttons/Button/Button'
import classes from './IconButton.module.scss'
import clsx from 'clsx'

export type IconButtonProps = Omit<ButtonProps, 'StartIcon' | 'EndIcon'>

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function CustomIconButton(props, ref) {
  return (
    <Button ref={ref} {...props} className={clsx(classes.root, props.className)}>
      {props.children}
    </Button>
  )
})

export default IconButton
